import {
  FindingSeveritySchema,
  FindingStatusSchema,
} from '@terra/shared-schemas-orchestrator';

export const FINDINGS_STATUS_SORT_ORDER = [
  FindingStatusSchema.enum.Unresolved,
  FindingStatusSchema.enum.InProgress,
  FindingStatusSchema.enum.Retest,
  FindingStatusSchema.enum.Resolved,
  FindingStatusSchema.enum.FalsePositive,
  FindingStatusSchema.enum.WontFix,
] as const;

export const FINDINGS_SEVERITY_SORT_ORDER = [
  FindingSeveritySchema.enum.Info,
  FindingSeveritySchema.enum.Low,
  FindingSeveritySchema.enum.Medium,
  FindingSeveritySchema.enum.High,
  FindingSeveritySchema.enum.Critical,
] as const;
